import i18n from 'i18next';
import { REGIMES_TRIBUTARIOS, ehRegimeTributario, type RegimeTributario } from '@malgoos/shared';
import { get } from '../../nucleo/api';

/**
 * Lote crm5 (E10, decisão C): "Regime tributário pretendido" da negociação. As opções são o catálogo único do regime da
 * empresa (`REGIMES_TRIBUTARIOS` de `@malgoos/shared`) com os rótulos do Cadastros (`cadastros:valores.regime.*`); a sugestão
 * é o regime em vigor da empresa (`GET /pipeline/crm/regime-sugerido`).
 */
export const rotuloRegime = (r: string | null | undefined): string => (ehRegimeTributario(r) ? i18n.t(`cadastros:valores.regime.${r}`) : '');

export const opcoesRegime = (): { valor: RegimeTributario; rotulo: string }[] => REGIMES_TRIBUTARIOS.map((r) => ({ valor: r, rotulo: rotuloRegime(r) }));

/** Regime em vigor da empresa, para o campo do formulário de criação (`preencher`); sem regime, nada a preencher. */
export async function sugestaoDeRegime(parceiroId: string): Promise<Record<string, unknown> | null> {
  const r = await get<{ regime: RegimeTributario | null }>('/pipeline/crm/regime-sugerido', { parceiro_id: parceiroId });
  return r.regime ? { regime_pretendido: r.regime } : null;
}
